import * as R from 'ramda';
import angular from 'angular';

export default function BulkArchiveReportInstanceController(
  $q,
  $rootScope,
  $scope,

  alerts,
  confirmDialog,
  loaderService,
  ssDialogService,
  reportsDataService,
  userService,
) {
  const vm = this;

  vm.canExpand = true;

  vm.handleBulkArchiveChange = _handleBulkArchiveChange;
  
  _activate();

  function _activate() { 
    _initPermissions();
  }

  function _handleBulkArchiveChange() {
    $rootScope.$broadcast('selectBulkReportInstanceChange');
  }

  function _initPermissions() {
    return userService.getUserPermissionSet('admin').then(permissions => {
      vm.permissions = permissions;
    });
  }
}

BulkArchiveReportInstanceController.$inject = [
  '$q',
  '$rootScope',
  '$scope',

  'alerts',
  'confirmDialog',
  'loaderService',
  'ssDialogService',
  'reportsDataService',
  'userService',
];
